import { memo, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { CreatorHeroLogo } from '@/components/layout/header/logo.tsx'
import { useAccount } from '@/modules/accounts/hooks/useAccounts'
import { RegisterForm } from '@/modules/accounts/ui/AccountRegisterForm'
import { AppRoutes } from '@/utils/constants'
import { classNames } from '@/utils/helpers'
import { useIsDarkTheme } from '@/utils/useTheme'

const _RegisterView = () => {
  const { isLoggedIn } = useAccount()

  const isDarkMode = useIsDarkTheme()

  const navigate = useNavigate()

  // Redirect user on login
  useEffect(() => {
    if (isLoggedIn) {
      navigate(AppRoutes.Overview.asUrl())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  return (
    <div
      className={classNames(
        "grid h-screen w-screen place-items-center bg-[url('/login-background.webp')] bg-no-repeat bg-cover",
        {
          "bg-[url('/login-background-dark.png')]": isDarkMode,
        },
      )}
    >
      <div className=" w-full px-6 py-9 rounded-xl bg-card shadow-2xl max-w-xl">
        <header className="flex flex-col items-center mb-10">
          <CreatorHeroLogo width={215} />
          <p className="font-medium text-sm text-text-sub mt-3">
            Enter your details below to create your account
          </p>
        </header>
        <RegisterForm />
      </div>
    </div>
  )
}

export const RegisterView = memo(_RegisterView)
